import template from './housing-type.jade';
import housingType from './../../../enums/housing-type';
import validation from './../../../services/validation';

// отвечает за флаг isApartments
export default angular
    .module('cian.addForm.housingType', [])
    .directive('cianAfAboutObjectHousingType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.items = housingType;

            this.validation = validation(this.form, 'housingType', {
                required: 'Выберите тип жилья',
            });
        },
        controllerAs: 'housingType',
        template,
    }))
    .name;
